import { Card, Tag } from '@digdir/designsystemet-react';

import styled from '../../../../../styled';

export const SummaryCard = styled(Card)`
  display: flex;
  flex-direction: column;
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: var(--ds-size-2);
  gap: var(--ds-size-8);
`;

export const SummaryTag = styled(Tag)`
  margin-block: 0;
`;

export const TiltakWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-8);
`;

export const TiltakCategoryWrapper = styled.div`
  display: inherit;
  flex-direction: inherit;
  gap: var(--ds-size-2);
`;
